import React, { useState } from "react";
import whiteTopImg from "../../assets/images/png/white_top_vector.png";
import orangeTopImg from "../../assets/images/png/orange_top_vector.png";
import bottomFlowerImg from "../../assets/images/svg/bottom_flower.svg";
import topFlowerImg from "../../assets/images/svg/top_flower.svg";
import rightDecorImg from "../../assets/images/characteristicsImage/svg/characteristics-right-icons.svg";
import leftDecorImg from "../../assets/images/characteristicsImage/svg/characteristics-left-icons.svg";
import Button from "../common/button/Button";
import CommonHeading from "../common/heading/CommonHeading";
import { characteristicsCardsData } from "../../utils/CharacteristicsHelper";

const DivineCharacteristics = () => {
  const [showAll, setShowAll] = useState(false);
  const handleViewAllClick = () => {
    setShowAll(!showAll);
  };
  return (
    <>
      <div className="bg_orange py-2 position-relative characteristics_bg z_index_1">
        {/* WHITE TOP VECTOR IMAGE */}
        {/* <img
          className="position-absolute end-0 w-100 white_top_vector"
          src={whiteTopImg}
          alt="white_top_vector"
        /> */}
        {/* BOTTOM ORANGE VECTOR IMAGE */}
        {/* <img
          className="position-absolute end-0 w-100 common_orange_bottom_layer"
          src={orangeTopImg}
          alt="orange_top_vector"
        /> */}
        {/* BOTTOM FLOWER VECTOR IMAGE 
        <img
          className="position-absolute end-0 bottom-0 characteristics_bottom_flower bottom_flower_mahamantra "
          src={bottomFlowerImg}
          alt="bottom_flower"
        />*/}
        {/* TOP FLOWER VECTOR IMAGE 
        <img
          className="position-absolute top_flower_mahamantra"
          src={topFlowerImg}
          alt="top_flower"
        />*/}
        {/* RIGHT VECTOR IMAGE */}
        <img
          className="position-absolute end-0 bottom-0 d-none d-xl-block"
          src={rightDecorImg}
          alt="characteristics-right-icons"
        />
        {/* LEFT VECTOR IMAGE */}
        <img
          className="position-absolute bottom-0 d-none d-xl-block"
          src={leftDecorImg}
          alt="characteristics-left-icons"
        />
        <div className="container container_modified pb-3 pb-lg-5 pb-xl-5 mt-1 mt-sm-1">
          <div className="pt-sm-3 pt-xl-5 mt-xl-3">
            <CommonHeading
              heading="Hari Om Tatsat Jai Guru Datta"
              className="text-light-yellow common_heading_text"
            />
            <h4 className="font-2xl fw-bold text-white px-md-5 mx-lg-5 text-center mb-0 pt-2">
              The Divine Characteristics Of The Mahamantra
            </h4>
            <p className="font-sm fw-medium text-white text-center pt-3 lh_25">
              In availability, certainty of performance and holistic effects,
              the Divine gift entrusted to Bapu - coming
              <br className="d-none d-lg-block" />
              from the Lord's own mouth - is a spiritual tool forged in trust.
              <br className="d-none d-lg-block" />
              The Great Mantra is supercharged, and untold are its graces. Yet
              Hari Om Tatsat Jai Guru Datta can be
              <br className="d-none d-lg-block" />
              recognized as a Divine boon by the following fragrances of its
              Supreme origin:
            </p>
          </div>
          <div className="row pt-md-4 justify-content-center pb-2 pb-md-0">
            {characteristicsCardsData.map((obj, index) => {
              return (
                <div
                  className={`${
                    !showAll && index >= 4 ? "d-none d-md-block" : ""
                  } col-12 col-sm-8 col-md-6 col-lg-4 pt-2 pt-md-4 position-relative z_index_1`}
                  key={index}
                >
                  <div className="characteristics_box transition_03 d-flex justify-content-center align-items-center text-center px-4">
                    <h6 className="mb-0 font-sm fw-medium text-brown lh_25 characteristics_para">
                      {obj.title}
                    </h6>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="d-md-none">
            <Button
              title={showAll ? "View Less" : "View All"}
              onClick={handleViewAllClick}
              className="view_all_btn"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default DivineCharacteristics;
